<!-- src/components/Modal.svelte -->
<script>
    import { createEventDispatcher, onMount } from "svelte";
    import { fade, scale } from 'svelte/transition';
    import { refreshCurrentSiteCount } from '$stores/messageCountStore';

    const dispatch = createEventDispatcher();

    export let messageTitle = "";
    export let messageBody = "";
    export let participantLanguage = "English";
    export let isOpen = true;

    let translatedTitle = "";
    let translatedBody = "";

    const RTL_LANGUAGES = [
        "Arabic",
        "Hebrew",
        "Persian",
        "Farsi",
        "Urdu",
        "Aramaic",
        "N'Ko",
        "Mandaic",
        "Samaritan",
        "Syriac"
    ];

    function isRTL(language) {
        return RTL_LANGUAGES.includes(language);
    }

    async function closeModal() {
        // Refresh the message count when a message is viewed
        await refreshCurrentSiteCount();
        dispatch('close');
    }

    onMount(async () => {
        // Refresh the message count when a message modal is opened
        await refreshCurrentSiteCount();
    });

    async function translateText(text) {
        const response = await fetch(`https://translation.googleapis.com/language/translate/v2?key=AIzaSyD_CoJEaSmNJl92VrrEQRiPq9R3blhJp3c`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                q: text,
                target: 'en',
                format: 'text'
            })
        });

        if (!response.ok) {
            console.error('Translation API error:', response.statusText);
            return text; // Fallback to original text if translation fails
        }

        const data = await response.json();
        return data.data.translations[0].translatedText;
    }

    $: if (participantLanguage !== "English") {
        translateText(messageTitle).then(translated => translatedTitle = translated);
        translateText(messageBody).then(translated => translatedBody = translated);
    } else {
        translatedTitle = "";
        translatedBody = "";
    }
</script>

{#if isOpen}
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <!-- svelte-ignore a11y-no-static-element-interactions -->
    <div 
        class="fixed inset-0 z-50 flex items-center justify-center backdrop-blur-sm"
        on:click={closeModal}
        transition:fade={{ duration: 200 }}
    >
        <div class="modal-overlay absolute inset-0 bg-slate-800 opacity-75"></div>
        <div 
            class="bg-white dark:bg-gray-900 p-4 rounded-lg shadow-lg w-full max-w-xl relative z-60"
            on:click|stopPropagation
            transition:scale={{ duration: 400, start: 0.95 }}
        >
            <button 
                class="absolute top-0 right-2 text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200" 
                on:click={closeModal}
            >&times;</button>
            
            <p class="text-xs text-gray-600 dark:text-gray-500 mb-2">Original Message to Participant</p>
            <h2 class="text-m text-gray-600 dark:text-gray-200 font-bold mb-0 {isRTL(participantLanguage) ? 'direction-rtl' : ''}">{messageTitle}</h2>
            <p class="text-s text-gray-600 dark:text-gray-200 {isRTL(participantLanguage) ? 'direction-rtl' : ''} {participantLanguage === 'English' ? 'mb-0' : 'mb-10'}">{messageBody}</p>

            {#if participantLanguage !== "English" && translatedTitle && translatedBody}
                <p class="text-xs text-gray-600 dark:text-gray-500 mb-2">Machine Translation</p>
                <h2 class="text-m text-gray-600 dark:text-gray-400 mb-0">{translatedTitle}</h2>
                <p class="text-s text-gray-600 dark:text-gray-400 font-light mb-0">{translatedBody}</p>
            {/if}
        </div>
    </div>
{/if}

<style>
    .direction-rtl {
        direction: rtl;
    }
</style>